






























import { computed, defineComponent, PropType } from '@vue/composition-api';
import { TargetItem } from '../../types/common';
import { showD } from '../../config';

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<TargetItem>,
            default: () => {},
        },
        type: {
            type: String,
            default: 'rewards', // rewards, gifts
        },
    },
    emits: ['clickFunction'],
    setup(props) {
        const showGift = computed(() => props.type === 'gifts' && props.item.price);
        return {
            showD,
            showGift,
        };
    },
});
